import { defineMessages } from 'react-intl';

export const dqlEditorMessages = defineMessages({
  openPanel: {
    defaultMessage: 'Open',
    id: 'QPVwTdDxajDwh62B',
    description:
      'Label next to the Ctrl+Space keyboard shortcut in the DQL editor autocomplete info section, describing the action the shortcut triggers.',
  },
  closePanel: {
    defaultMessage: 'Close',
    id: 'i7ML7nsvim1vfXlT',
    description:
      'Label next to the Esc keyboard shortcut in the DQL editor autocomplete info section, describing the action the shortcut triggers.',
  },
  dqlSyntaxLink: {
    defaultMessage: 'DQL syntax',
    id: 'anCkyfyzovTz3qtv',
    description:
      'Link text in the DQL editor autocomplete info section, pointing to the external DQL syntax documentation.',
  },
});
